export default __webpack_public_path__ + "static/media/WAS0333.34I-41671_-24942_0.818e5a06.jpg";